// extracted by mini-css-extract-plugin
export default {"contact":"styles_contact__es9q8","socialMedia":"styles_socialMedia__rIa+q"};